// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__RQw6s","brand":"Navigation_brand__3+bnq","email":"Navigation_email__o6UbK"};